export const lightTheme = {
  primary: '#2563eb',
  primaryDark: '#1e40af',
  secondary: '#3b82f6',
  background: '#f8fafc',
  backgroundLight: '#ffffff',
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textLight: '#ffffff',
  shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  border: '#e2e8f0',
  hover: '#f1f5f9',
  accent: '#f43f5e'
};

export const darkTheme = {
  primary: '#60a5fa',
  primaryDark: '#3b82f6',
  secondary: '#93c5fd',
  background: '#0f172a',
  backgroundLight: '#1e293b',
  textPrimary: '#f8fafc',
  textSecondary: '#cbd5e1',
  textLight: '#ffffff',
  shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
  border: '#334155',
  hover: '#334155',
  accent: '#f43f5e'
};

export type Theme = typeof lightTheme;